// source: pbtypes/gen/scan_planner/vertex_column_scan_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.scan_planner.VertexColumnScanRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.VertexColumnScanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.VertexColumnScanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.VertexColumnScanRequest.displayName = 'proto.scan_planner.VertexColumnScanRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.VertexColumnScanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.VertexColumnScanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.VertexColumnScanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.VertexColumnScanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
verticalOverlapFraction: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
desiredRange: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
lengthTower: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
upAndOverHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.VertexColumnScanRequest}
 */
proto.scan_planner.VertexColumnScanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.VertexColumnScanRequest;
  return proto.scan_planner.VertexColumnScanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.VertexColumnScanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.VertexColumnScanRequest}
 */
proto.scan_planner.VertexColumnScanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitch(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setVerticalOverlapFraction(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDesiredRange(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLengthTower(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setUpAndOverHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.VertexColumnScanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.VertexColumnScanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.VertexColumnScanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.VertexColumnScanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGimbalPitch();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getVerticalOverlapFraction();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getDesiredRange();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getLengthTower();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getUpAndOverHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
};


/**
 * optional float gimbal_pitch = 1;
 * @return {number}
 */
proto.scan_planner.VertexColumnScanRequest.prototype.getGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.VertexColumnScanRequest} returns this
 */
proto.scan_planner.VertexColumnScanRequest.prototype.setGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float vertical_overlap_fraction = 2;
 * @return {number}
 */
proto.scan_planner.VertexColumnScanRequest.prototype.getVerticalOverlapFraction = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.VertexColumnScanRequest} returns this
 */
proto.scan_planner.VertexColumnScanRequest.prototype.setVerticalOverlapFraction = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float desired_range = 3;
 * @return {number}
 */
proto.scan_planner.VertexColumnScanRequest.prototype.getDesiredRange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.VertexColumnScanRequest} returns this
 */
proto.scan_planner.VertexColumnScanRequest.prototype.setDesiredRange = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float length_tower = 4;
 * @return {number}
 */
proto.scan_planner.VertexColumnScanRequest.prototype.getLengthTower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.VertexColumnScanRequest} returns this
 */
proto.scan_planner.VertexColumnScanRequest.prototype.setLengthTower = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float up_and_over_height = 5;
 * @return {number}
 */
proto.scan_planner.VertexColumnScanRequest.prototype.getUpAndOverHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.VertexColumnScanRequest} returns this
 */
proto.scan_planner.VertexColumnScanRequest.prototype.setUpAndOverHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


goog.object.extend(exports, proto.scan_planner);
